const getTimeDiff = (date) => Math.abs(new Date(date).getTime() - Date.now());
export default getTimeDiff;
//# sourceMappingURL=getTimeDiff.js.map